module.exports = __webpack_public_path__ + "img/tbx_code_2.a9c95e52.jpg";